import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import { scrollingHelpers } from 'day8-react';
import { analyticsHelpers } from 'day8-ui';
import { Alert } from 'day8-react/build/new-components';
import { createProductBooking } from '../../actions/booking';
import { getQuery } from '../../helpers/querystring';
import history from '../../history';
import StartBookingSkeleton from './StartBookingSkeleton';

const StartProductBooking = ({
  location, match, createProductBooking, error, isYachtsAndFriends, user
}) => {
  const [loading, setLoading] = useState(true);
  const query = getQuery(location);
  useEffect(() => {
    scrollingHelpers.scrollToTop();
  }, []);
  useEffect(() => {
    if (user && user.id) {
      const startBooking = async () => {
        try {
          const { standardYachtWeekId } = match.params;
          let {
            girls, boys, skipper, hostess, planId, extras
          } = query;
          const { currency } = query;
          girls = girls && parseInt(girls, 10);
          boys = boys && parseInt(boys, 10);
          skipper = skipper && parseInt(skipper, 10);
          hostess = hostess && parseInt(hostess, 10);
          planId = planId && parseInt(planId, 10);
          // add_to_cart fires on every book-button click (here, when the temporary booking is created);
          // begin_checkout is fired later when the user lands on the payment page (containers/booking/Payment.js)
          const createdBooking = await createProductBooking(
            standardYachtWeekId,
            girls,
            boys,
            skipper,
            hostess,
            currency,
            planId,
            extras
          );
          analyticsHelpers.addToCart(createdBooking);
          setLoading(false);
        } catch (err) {
          console.error(err);
          setLoading(false);
        }
      };
      startBooking();
    } else {
      history.push({
        state: {
          showLoginModal: true,
          page: 'login',
          returnTo: { pathname: location.pathname, search: location.search },
          shouldValidateUser: true
        }
      });
    }
  }, [user]);

  if (loading) {
    return <StartBookingSkeleton />;
  }

  if (error) {
    return (
      <Alert
        className="margin-top-md width-40% margin-left-md"
        title="Something went wrong"
        text={error.message}
        type="notification"
        show
      />
    );
  }

  return <Redirect to={`/booking/${isYachtsAndFriends ? 'yachtsandfriends/' : ''}payment${query.paymentOption ? `?paymentOption=${query.paymentOption}` : ''}`} />;
};

StartProductBooking.propTypes = {
  match: PropTypes.object,
  user: PropTypes.object,
  createProductBooking: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  error: PropTypes.object,
  isYachtsAndFriends: PropTypes.bool
};

const mapStateToProps = store => ({
  user: store.user.loggedUser,
  error: store.booking.error
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      createProductBooking
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StartProductBooking);
